
import React, { FC, CSSProperties } from 'react'
import './FilterCourseCard.scss'
import TimeService from 'app_services/time/timeService';
import ShareModule, { ShareModuleYPosition } from 'app_components/modules/ShareModule/ShareModule';
import { routingService } from 'app_services/routingService';
import { BiShareAlt } from "react-icons/bi";
import { Link } from 'react-router-dom';
import { CourseSchedulingModes } from 'app_types/admin/courseScheduling/courseSchedulingModeTypes';
import { CourseFormationType } from 'app_types/admin/course/courseTypes';
import { FORMATION_TYPE_TRANSLATIONS } from 'app_types/campus/academic/courseTypes';

interface IFilterCourseCardProps {
  modality?: string
  name?: string
  startDate?: string
  duration?: number
  image?: string
  courseId: string
  slug: string
  schedule?: string
  formationType?: CourseFormationType
  serviceInformation?: string
  height?: string
  sharePosition?: ShareModuleYPosition
  withoutTutor?: boolean
  quickLearning?: boolean
  isMooc?: boolean
  masterClass?: boolean
}


const FilterCourseCard: FC<IFilterCourseCardProps> = ({
  modality,
  name,
  startDate,
  duration,
  image,
  courseId,
  slug,
  schedule,
  serviceInformation,
  height,
  sharePosition,
  withoutTutor,
  formationType,
  quickLearning,
  isMooc,
  masterClass
}) => {
  const timeService = new TimeService()

  const getStylesFromType = (): CSSProperties => {
    if (isMooc) {
      return {
        backgroundColor: '#0085CA',
        color: '#E5F7FF'
      }
    }
    if(quickLearning){
      return {
        backgroundColor: '#2EB9FF',
        color: '#002E5D'
      }
    }
    if(masterClass){
      return {
        backgroundColor: '#002E5D',
        color: '#E5F7FF'
      }
    }
    if(formationType === CourseFormationType.DIPLOMA){
      return {
        backgroundColor: '#E5F7FF',
        color: '#25252A'
      }
    }
    if(formationType === CourseFormationType.COURSE){
      return {
        backgroundColor: '#939399',
        color: '#25252A'
      }
    }
    if (formationType === CourseFormationType.PROGRAM) {
      return {
        backgroundColor: '#D8D8DA',
        color: '#25252A'
      }
    }
    return {
      backgroundColor: '#0085CA',
      color: '#E5F7FF'
    }
  }
  const courseModalityColor = () => {
    if (modality === CourseSchedulingModes.VIRTUAL) {
      return '#FF4841'
    }
    if (modality=== CourseSchedulingModes.ON_LINE) {
      return '#8246AF'
    }
    if (modality === CourseSchedulingModes.ON_SITE) {
      return '#009336'
    }
    return '#FF4841'
  }

  const getModalityNameFromType = () => {
    if (quickLearning) {
      return 'Quick learning'
    }
    if (isMooc) {
      return "MOOC'S"
    }
    if (masterClass) {
      return 'Master class'
    }
    return formationType ? FORMATION_TYPE_TRANSLATIONS[formationType] : ''
  }


  return (
    <Link to={{
      pathname: routingService.getPublicPath(`/curso/${slug}`),
      state: { courseId }
    }}>
      <div className='filter-course-card--container' style={{ height }}>

          <div className='filter-course-card--container-image'>
            <img className='filter-course-card--image' src={image} alt={`Imagen del ${name}`} />
            {(formationType || quickLearning || masterClass || isMooc) && (
              <div className='filter-course-card--type-course-container'>
                <div
                  className='filter-course-card--type-course'
                  style={getStylesFromType()}
                >
                  {getModalityNameFromType()}
                </div>
              </div>
            )}
            <div className='filter-course-card--modality-container'>
              <div
                className='filter-course-card--modality'
                style={{
                  color: courseModalityColor(),
                  width: serviceInformation?.length ? '56%' : '100%'
                }}
              >
                {modality}
              </div>
              {!!serviceInformation?.length && (
                <div
                  className='filter-course-card--add-free-course'
                >
                  {serviceInformation}
                </div>
              )}
            </div>
          </div>
          <div className='filter-course-card--text-container'>
            <h3 style={{fontSize: 16, margin: 10}}>{name}</h3>
          </div>
          <div className='filter-course-card--container-information'>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
              {!withoutTutor && (
                <p className='filter-course-card--course-information'>Inicio: {startDate}</p>
              )}
              <p className='filter-course-card--course-information'>Duración: {timeService.secondsFormatHMS(duration as number, 'HH')}H</p>
              {!!schedule?.length && (
                <p className='filter-course-card--course-information'>Horario: {schedule}</p>
              )}
              {withoutTutor && (
                <p
                  className='filter-course-card--course-information'
                  style={{
                    color: 'var(--primary)',
                    marginTop: '5px'
                  }}
                >
                  * SIN TUTOR *
                </p>
              )}
            </div>
          </div>
          <div className='filter-course-card--container-icon' onClick={(e) => e.stopPropagation()}>
            <ShareModule
              share={routingService.getPublicPath(`/curso/${courseId}`)}
              icon={<BiShareAlt color='var(--primary)'/>}
              yPosition={sharePosition}
            />
          </div>
      </div>
    </Link>
  )
}

export default FilterCourseCard
